import styled from 'styled-components';
import {
  BREAKPOINT_SMALL,
  BREAKPOINT_MEDIUM,
  DEFAULT_MOBILE_PADDING,
  MarketingHeading1,
  MarketingSection,
} from 'components/MarketingPagesShared/styles';

export const SwitchHeroGrid = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  /* In SwitchHeroSecondaryImages, the parent container becomes a flex layout and we need this child to take up all available space */
  @media (max-width: ${BREAKPOINT_SMALL}px) {
    max-width: 66%;
  }
`;

export const SwitchHeroGridImage = styled.div`
  width: 50%;
  &:nth-of-type(even) {
    align-self: flex-end;
  }
`;

export const SwitchHeroGridImageReversedOnNarrow = styled.div`
  width: 50%;
  &:nth-of-type(even) {
    align-self: flex-end;
  }
  @media (max-width: ${BREAKPOINT_SMALL}px) {
    &:nth-of-type(odd) {
      align-self: flex-end;
    }
    &:nth-of-type(even) {
      align-self: flex-start;
    }
  }
`;

export const SwitchHeroPrimary = styled(MarketingSection)`
  && {
    display: grid;
    grid-template-columns: 2fr minmax(300px, 1fr);
    grid-column-gap: 45px;
    grid-row-gap: 45px;
    padding-bottom: 35px;
    @media (min-width: ${BREAKPOINT_SMALL}px) {
      padding-right: 0;
    }
    @media (max-width: ${BREAKPOINT_SMALL}px) {
      grid-template-columns: 1fr;
    }
  }
`;

export const SwitchHeroPrimaryText = styled.div`
  align-self: center;
`;

export const SwitchHeroPrimaryImages = styled.div`
  @media (max-width: ${BREAKPOINT_SMALL}px) {
    margin-left: -${DEFAULT_MOBILE_PADDING}px;
  }
`;

export const SwitchHeroSecondaryImages = styled.div`
  @media (max-width: ${BREAKPOINT_SMALL}px) {
    display: flex;
    justify-content: flex-end;
    margin-right: -${DEFAULT_MOBILE_PADDING}px;
  }
`;

export const SwitchHeroTitle = styled(MarketingHeading1)`
  margin: 50px 0 100px 0;
  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    br {
      display: none;
    }
  }
  @media (max-width: ${BREAKPOINT_SMALL}px) {
    font-size: 3rem;
    margin: 45px 0;
  }
`;

export const SwitchHeroSecondary = styled(MarketingSection)`
  && {
    display: grid;
    grid-template-columns: minmax(300px, 1fr) 2fr;
    grid-column-gap: 45px;
    grid-row-gap: 45px;
    @media (min-width: ${BREAKPOINT_SMALL}px) {
      padding-left: 0;
    }
    @media (max-width: ${BREAKPOINT_MEDIUM}px) {
      padding-right: ${DEFAULT_MOBILE_PADDING}px;
      padding-bottom: 80px;
    }
    @media (max-width: ${BREAKPOINT_SMALL}px) {
      display: flex;
      flex-direction: column-reverse;
      grid-row-gap: 0;
    }
  }
`;

export const SwitchHeroSecondaryText = styled.p`
  align-self: flex-end;
  color: white;
  font-size: 2.25rem;
  line-height: 1.2;
  width: 75%;
  margin-left: 20%;
  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    width: auto;
    margin-left: 20px;
  }
  @media (max-width: ${BREAKPOINT_SMALL}px) {
    width: auto;
    font-size: 1.75rem;
    margin: 45px 0 20px;
  }
`;
